import { Box, Modal, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  getExternalReferralAccesses,
  getWareHouseAccesses,
} from "../../api/group";

import userPic from "../../assets/image/user-profile3.png";
import TableErjaAdmin from "./tableErjaAdmin";

export default function ErjaAdminPop({ open, setOpen, equipment, erja, drug }) {
  const [Options, setOptions] = useState();
  const [userInfo, setUserInfo] = useState();
  const [DataUsers, setDataUsers] = useState();

  const handleClose = () => {
    setOpen(false);
  };
  // console.log(DataUsers);
  useEffect(() => {
    if (open === true) {
      if (equipment) {
        getWareHouseAccesses()
          .then((x) =>
            setDataUsers(() => {
              const filteredData = x.filter(
                (item) => item.hasAccessForEquipment
              );
              return filteredData;
            })
          )
          .catch(() => {});
      } else if (drug) {
        getWareHouseAccesses()
          .then((x) =>
            setDataUsers(() => {
              const filteredData = x.filter((item) => item.hasAccessForDrug);
              return filteredData;
            })
          )
          .catch(() => {});
      } else {
        getExternalReferralAccesses()
          .then((x) => {
            setDataUsers(x);
          })
          .catch(() => {});
      }
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 700,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={userPic} />
          </Box>
          <Box display="grid" height="350px" width={"100%"} pl="20px">
            <Box>
              <Typography fontSize="18px" fontWeight={"bold"}>
                {"کاربران ارجاع"}
              </Typography>
            </Box>
            <Box
              height={"280px"}
              width="100%"
              bgcolor="#F5F9FF"
              boxShadow="0px 4px 4px 0px #00000040"
              borderRadius={"9px"}
              p="20px"
            >
              <Typography color="var(--emr-blue)" fontWeight={"bold"}>
                کاربران
              </Typography>
              <Box>
                <TableErjaAdmin
                  equipment={equipment}
                  drug={drug}
                  rowData={DataUsers}
                  setRowData={setDataUsers}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
